let actions = {}

export default actions



// WEBPACK FOOTER //
// ./src/vuex/action.js